import React, { useEffect, useState } from 'react';
import 'react-day-picker/lib/style.css';
import SlotPicker from '../SlotPicker/index';
import DatePicker from '../DatePicker/index';
import actionConstants from '../../services/scheduler/constants';
import { useDispatch, useSelector } from 'react-redux'
import HourSlots from '../SlotPicker/HourSlots';
import { InfoMessage } from './../Messages/index';
const dateFormat = 'MM/DD/YYYY'

const Scheduler = ({
    submitSenderer = () => null,
    customTimeSlots = null,
    hoursMultiselect = true,
    datePickerModifiers,
    readOnly = false,
    IsSeller = false,
    IsBuyer = false,
    buyerSchedules
}) => {
    const dispatch = useDispatch();
    const activeDay = useSelector(state => state.scheduler.activeDateSlot);
    const schedule = useSelector(state => state.scheduler.schedule);
    var selectedDays = useSelector(state => Object.keys(state.scheduler.schedule))
    const [isSlotEmpty, setIsSlotEmpty] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);

    if (selectedDays !== undefined && selectedDays !== null && selectedDays.length > 0) {
        selectedDays = selectedDays.sort(function (a, b) {
            a = new Date(a);
            b = new Date(b);
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
        });
    }



    useEffect(() => {
        if (IsSeller) {
            checkIsEmpty(activeDay, true);
            if (selectedDay === null || selectedDay === undefined || selectedDay === "") {
                setSelectedDay(activeDay);
            }
        }
    }, [activeDay, schedule])

    const handleDayClick = (day) => {
        //if (!readOnly) {
        //    showSlot(day);
        //} 
        if (readOnly === true) {
            if (checkDateExists(day)) {
                showSlot(day);
            }
            return;
        }

        if (customTimeSlots) {
            if (checkDateExists(day)) {
                showSlot(day);
            }
            return;
        }

        if (IsBuyer && (readOnly !== true && readOnly !== false && readOnly !== "")) {
            if (checkDateExists(day)) {
                showSlot(day);
            }
            return;
        }
        //if (readOnly || customTimeSlots) return;

        if (IsSeller) {
            let isSelectedSlot = checkEmptySlotOrNot(day, false)
            if (isSelectedSlot) {
                dispatch({ type: actionConstants.TOGGLE_DAY, data: day });
                setIsSlotEmpty(false)
                setSelectedDay(day)
            }
            else {
                setIsSlotEmpty(true)

            }
        }
        else {
            dispatch({ type: actionConstants.TOGGLE_DAY, data: day });
        }
    }

    const isEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }
    
    const checkDateExists = (day) => {
        var isvalid = false;
        if (!isEmpty(schedule)) {
            if (schedule[day] !== undefined) {
                isvalid = true;
            }
        }
        return isvalid;
    }

    const checkEmptySlotOrNot = (day, isCheckCurrentDay) => {
        var isvalid = true;
        if (!isEmpty(schedule)) {
            if (!schedule[day] || isCheckCurrentDay === true) {
                for (let key in schedule) {
                    if (schedule[key].length <= 0) {
                        isvalid = false
                    }
                }
            }
        }
        return isvalid;
    }

    const showSlot = (value) => {
        dispatch({ type: actionConstants.SET_ACTIVE_DAY_SLOT, data: value })
    }
    const checkIsEmpty = (day, IsCheckInCurrentDay) => {
        var isSelectedSlot = "";
        if (IsSeller) {
            isSelectedSlot = checkEmptySlotOrNot(day, IsCheckInCurrentDay)
            if (isSelectedSlot) {
                setIsSlotEmpty(false)
            }
            else {
                setIsSlotEmpty(true)
            }
        }
        else {
            isSelectedSlot = true;
        }
        return isSelectedSlot;
    }
    const setActiveDate=(activeDay) => {
        setSelectedDay(activeDay);
    }
    const handleSlotClick = (data) => {
        if (readOnly) return;
        dispatch({ type: actionConstants.TOGGLE_SLOT, data })
        checkIsEmpty(data.activeDay, false);
    }

    return (
        <div className='scheduler'>
            <div className='scheduler__left'>
                {<DatePicker
                    selectedDays={selectedDays}
                    onChange={handleDayClick}
                    format={dateFormat}
                    numberOfMonths={2}
                    modifiers={datePickerModifiers}
                    readOnly={readOnly || customTimeSlots}
                />}
                
                {
                    IsSeller && !buyerSchedules && isSlotEmpty &&
                    <div className="empty-slot-required-info">                        
                        <InfoMessage title={'Please set your appointment time for ' + selectedDay + '. You can add more dates after setting your time slots. To remove a date, click the selected date on the calendar. Once finished, you can confirm your selection(s) by clicking the box(es) below.'} />
                    </div>
                }
                {
                    IsSeller && buyerSchedules && isSlotEmpty && (
                        <div className="empty-slot-required-info">
                            <InfoMessage title={'Click the highlighted dates to view proposed time and confirm your availability.'} />
                        </div>)
                }
                <SlotPicker
                    selectedDays={selectedDays}
                    buyerSchedules={buyerSchedules}
                    checkIsEmpty={(day, IsCheckInCurrentDay) => checkIsEmpty(day, IsCheckInCurrentDay)}
                    setActiveDate={(activeDay) => setActiveDate(activeDay)}
                />

            </div>
            <div className='scheduler__right'>
                <HourSlots
                    step={30}
                    dateRange={['06:00', '17:00']}
                    activeDay={activeDay}
                    selectedSlots={schedule[activeDay]}
                    onChange={handleSlotClick}
                    customTimeSlots={customTimeSlots}
                    multiselect={hoursMultiselect}
                    readOnly={readOnly}
                    setActiveDate={(activeDay) => setActiveDate(activeDay)}
                />
            </div>

            <div className='submit-renderer'>{submitSenderer()}</div>
        </div>
    );
}

export default Scheduler